export default __webpack_public_path__ + "static/media/group.e2bb8cf5.svg";